import React from 'react';
import { products } from '../data/mock';

export const ProductsSection = () => {
  return (
    <section id="produkte" className="py-16 sm:py-24 lg:py-32 bg-[#f7f5f2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block text-[#61525a] font-medium text-xs sm:text-sm tracking-wider uppercase mb-3 sm:mb-4">
            Unsere Auswahl
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e1919] mb-4 sm:mb-6">
            Frisch aus der Backstube
          </h2>
          <p className="text-[#736c64] text-base sm:text-lg max-w-2xl mx-auto px-2">
            Täglich frisch gebacken mit den besten Zutaten – 
            traditionelle Rezepte, die seit Generationen begeistern.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {products.map((product, index) => (
            <div
              key={product.id}
              className="group relative bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg transition-all duration-500 hover:-translate-y-3 hover:shadow-2xl"
            >
              {/* Image */}
              <div className="relative h-48 sm:h-56 lg:h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.category}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1e1919]/60 via-transparent to-transparent" />
                
                {/* Category Badge */}
                <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4">
                  <span className="bg-[#61525a] text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium">
                    {product.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4 sm:p-6">
                <ul className="space-y-1.5 sm:space-y-2">
                  {product.items.map((item, idx) => (
                    <li
                      key={idx}
                      className="flex items-center gap-2 sm:gap-3 text-[#736c64] text-sm sm:text-base transition-colors duration-300 group-hover:text-[#1e1919]"
                    >
                      <span className="w-1.5 h-1.5 bg-[#fad24b] rounded-full flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Hover Overlay */}
              <div className="absolute inset-0 border-2 border-transparent rounded-2xl sm:rounded-3xl transition-all duration-300 group-hover:border-[#61525a]/20" />
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-10 sm:mt-16 text-center">
          <p className="text-[#736c64] mb-3 sm:mb-4 text-sm sm:text-base">Und vieles mehr...</p>
          <a
            href="#kontakt"
            className="inline-flex items-center gap-2 text-[#61525a] font-medium text-sm sm:text-base hover:text-[#4a3f45] transition-colors duration-300"
          >
            Besuchen Sie uns für die volle Auswahl
            <span className="text-xl">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
